import "./Table.css";
// `colgroup` + `fixed` are optional, used by tables with resizable columns:
// fixed table-layout makes the <col> widths authoritative so dragging a
// column edge actually resizes it.
export default function Table({ heading, body, colgroup, fixed }) {
  return (
    <div
      className={` align-middle inline-block min-w-full  shadow border-b border-gray-200 sm:rounded-lg`}
    >
      <table
        className="min-w-full divide-y divide-gray-200"
        style={fixed ? { tableLayout: "fixed" } : undefined}
      >
        {colgroup}
        <thead className="bg-gray-50">
          <tr>{heading}</tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">{body}</tbody>
      </table>
    </div>
  );
}
